import React from 'react'
import type {IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'

export type PearCommerceStoreLocatorContentItem = IContentItem<{
	// No specific elements needed for this component
}>

export const PearCommerceStoreLocator: Block<
	PearCommerceStoreLocatorContentItem
> = () => {
	return (
		<div
			data-kontent-element-codename="pear_commerce_store_locator_guidelines"
			id="pear-map-target"
		/>
	)
}
